<template>
  <div>
    <div class="w100 white text-center">
      <b-form @submit.prevent="login">
        <div class="p4 w100">
          <span class="welcome-to-soundsys pt-4">{{ $t('login') | capitalize }}</span>
        </div>

        <div class="p4 w100 text-left">
          <span class="w80 le">{{ $t("email") | capitalize }}:</span>
        </div>

        <div class="w100">
          <input
            id="email"
            v-model="email"
            type="email"
            class="login w80"
          >
        </div>

        <div class="p4 w100 text-left">
          <span class="w80 le">{{ $t("password")|capitalize }}:</span>
        </div>

        <div class="w100">
          <input
            id="password"
            v-model="password"
            class="login w80"
            type="password"
          >
        </div>

        <transition name="fade">
          <div
            v-if="error"
            class="error"
          >
            <span class="child">{{ fix(error) }}</span>
          </div>
        </transition>

        <div class="p4 w100 text-right">
          <span
            class="forgot ri"
            @click="recovery=true"
          >{{ $t('forgot_your_password') }}</span>
        </div>

        <div class="pb-4 pt-2 w100">
          <button
            type="submit"
            id="login"
            class="btn w80 btns btn-primary"
          >
            <spinner v-if="loading" />
            <span v-else>{{ $t('login') | capitalize }}</span>
          </button>
        </div>
      </b-form>
    </div>

    <modal v-if="recovery">
      <template v-slot:header>
        <div class="no-border text-center w100 welcome-to-soundsys">
          <span>{{ $t('password_recovery') }}</span>
          <i
            class="pl-2 fa fa-times pointer small"
            style="float:right;"
            @click="recovery=false"
          />
        </div>
      </template>

      <template v-slot:body>
        <div
          v-if="!modal_success&&!modal_err"
          class="w100 text-center pb-4"
        >
          <span class="please-login-or-sign">{{ $t('please_indicate_a_recovery_email') }}</span>
        </div>

        <div class="w100 text-center">
          <transition name="fade">
            <span
              v-if="modal_err && !modal_success"
              key="err"
              class="error"
            >{{ modal_err }}</span>
          </transition>
          <transition name="fade">
            <span
              v-if="modal_success"
              key="suc"
              class="text-success"
              v-html="modal_success"
            />
          </transition>
          <input
            v-if="!modal_success"
            key="nor"
            v-model="email"
            class="login w80"
            type="email"
            placeholder=" Email"
          >
        </div>
      </template>

      <template v-slot:footer>
        <div class="text-center w100">
          <span
            v-if="!modal_success"
            class="btn btns btn-primary"
            @click="sendRecovery"
          >
            {{ $t('send') | capitalize }}
          </span>
          <span
            v-if="!modal_success"
            class="btn btns btn-outline-secondary"
            @click="cancel"
          >
            {{ $t('cancel') | capitalize }}
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>


<style lang="scss" scoped>
div.modal-header {
  border-style: none !important;
}

.modal-footer {
  border-style: none !important;
}

.modal-container {
  max-width: 400px !important;
}

.modal-container input,
.modal-container span {
  font-family: "CircularStd", sans-serif;
}

.white {
  background-color: white;
}
</style>


<style lang="scss" scoped>
@import "../../../assets/styles/login.scss";
</style>


<script>
import { ApiCalls } from "@/assets/libs/services"
import { get } from "lodash"

export default {
  name: "Login",
  data () {
    return {
      recovery: false,
      loading: false,
      password: "",
      email: "",
      error: "",
      modal_success: "",
      modal_err: ""
    }
  },
  watch: {
    recovery (val) {
      if (val) {
        this.modal_success = ""
        this.modal_err = ""
      }
    }
  },
  methods: {
    cancel () {
      this.recovery = false
      this.email = ""
      this.password = ""
    },
    sendRecovery () {
      const msg = `<p><i class="fa fa-check big big-check"></i></p>
             <p style="color:black">Please check your email</p><p style="color:black"> A recovery
            email has been sent from</p>
             <p style="color:black;font-weight:bold">ums-noreply@bmat.com</p>`

      let data = {
        email: this.email
      }
      ApiCalls.recovery(data)
        .then(() => {
          this.modal_success = msg
        })
        .catch(err => {
          this.modal_err = err.error
        })
    },
    fix (err) {
      return err.replace("username", "email")
    },
    login () {
      this.loading = true
      const logindata = {
        csrf: null,
        password: this.password,
        email: this.email
      }

      ApiCalls.login(logindata)
        .then(x => {
          const data = x.data
          this.loading = false
          this.$auth.authenticate(data).then(() => {
            ApiCalls.initial_setup().then(
              () => {
                this.$store.commit("soundsys/setDataReady", true)
                this.$store.commit("soundsys/setLogged", true)

                // Redirect after login, either to the path specified in the redirect query
                // or to the sound-recordings page.
                let nextRoute = get(this.$route.query, "redirect", { name: "sound-recordings" })
                this.$router.replace(nextRoute)
              },
              err => {
                window.console.log("initial_setup->", err)
                this.$store.commit("soundsys/setLogged", false)

                this.$router.app.$auth.logout()
                document.body.className += " fade-out"
              }
            )
          })
        })
        .catch(err => {
          window.console.log(err)
          this.loading = false

          this.error = err.error
        })
    }
  }
}
</script>
